<ion-split-pane
  class="split-pane"
  [disabled]="globals.NoSplitPane == null ? true : globals.NoSplitPane"
  contentId="main"
>
  <ion-menu
    type="overlay"
    side="start"
    menuId="LeftMenu"
    contentId="main"
    class="left-ion-menu"
  >
    <ion-header
      [hidden]="globals.NoLeftMenuHeader"
      style="height: 65px; background: #272727"
    >
      <ion-toolbar
        class="left-ion-toolbar"
        style="height: 55px; padding-left: 15px"
      >
        <img
          title="Extended Reality System"
          src="assets/img/STS.png"
          alt=""
          style="height: 30%; width: 30%; padding-top: 10px"
          id="step1"
        />
        <!-- <ion-buttons slot="end">
          <ion-menu-button
            auto-hide="false"
            style="font-size: 230px; padding-top: 8px"
          ></ion-menu-button>
        </ion-buttons> -->
      </ion-toolbar>
      <hr style="border: none; border-bottom: 1px solid #00cfff" />
    </ion-header>

    <ion-content class="left-ion-menu" id="step4">
      <ion-list class="leftmenu-ion-list">
        <ion-menu-toggle auto-hide="false" *ngFor="let page of appPages">
          <ion-item
            *ngIf="
              page.menuItem == true && globals.checkFunctionAccess(page.title)
            "
            menuClose
            [routerDirection]="'root'"
            (click)="mainMenuClick(page, appPages, page.url)"
            class="leftmenu-ion-item"
            [class.select]="selectedPageUrl === page.url"
          >
            <ion-icon
              slot="start"
              [name]="page.icon"
              class="leftmenu-ion-item"
              [class.selects]="selectedPageUrl === page.url"
              title="{{ page.title }}"
            ></ion-icon>
            <span style="padding-top: 15px">
              {{ page.title }}
              <ion-list>
                <ion-menu-toggle
                  auto-hide="false"
                  *ngFor="let s of page.children"
                >
                  <ion-item
                    *ngIf="
                      s.menuItem == true &&
                      page.open &&
                      globals.checkFunctionAccess(s.title)
                    "
                    menuClose
                    [routerDirection]="'root'"
                    (click)="subMenuClick(s, s.children, s.url)"
                    class="leftmenu-ion-item"
                    [class.select]="selectedPageUrl === s.url"
                  >
                    <ion-icon
                      slot="start"
                      [name]="s.icon"
                      class="leftmenu-ion-item"
                      [class.selects]="selectedPageUrl === s.url"
                    ></ion-icon>
                    <span> {{ s.title }}</span>
                    <ion-list>
                      <ion-menu-toggle
                        auto-hide="false"
                        *ngFor="let sc of s.children"
                      >
                        <ion-item
                          *ngIf="
                            sc.menuItem == true &&
                            s.open &&
                            globals.checkFunctionAccess(sc.title)
                          "
                          menuClose
                          [routerDirection]="'root'"
                          (click)="subSubMenuClick(sc, sc.children, sc.url)"
                          class="leftmenu-ion-item"
                          [class.select]="selectedPageUrl === sc.url"
                        >
                          <span>
                            {{ sc.title }}
                          </span>
                        </ion-item>
                      </ion-menu-toggle>
                    </ion-list>
                  </ion-item>
                </ion-menu-toggle>
              </ion-list>
            </span>
          </ion-item>
        </ion-menu-toggle>
        <br /><br /><br />
      </ion-list>
    </ion-content>

    <ion-row>
      <ion-col style="color: white; padding-left: 17px" id="menuStep2">
        <p>
          <a
            href="https://www.sts3d.co.za"
            target="_blank"
            style="
              text-decoration: none;
              color: rgb(128, 129, 132);
              font-weight: bold;
              font-size: 15px;
            "
          >
            powered by
            <img
              src="assets/img/STSLogo.png"
              alt=""
              style="height: 30%; width: 30%; vertical-align: -2px"
            />
          </a>
          <br />
          <a style="font-size: 10px"> COPYRIGHT {{ currentYear }}</a>
        </p>
      </ion-col>
      <ion-col size="2"
        ><p
          style="
            color: white;
            padding-top: 19px;
            padding-right: 1px;
            font-size: 12px;
            cursor: pointer;
          "
          (click)="openModal()"
        >
          v2.1.0
        </p></ion-col
      ></ion-row
    >
  </ion-menu>

  <ion-router-outlet
    main
    class="GlobalContentPage"
    id="main"
  ></ion-router-outlet>
</ion-split-pane>
